import { FC, useCallback, useState } from 'react';
import { Switch, Typography, Space } from 'antd';
import { useUIDispatchContext } from 'providers/UI';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { parseJson, SettingsKeys } from '@medicusunion/front-utils';
import { UPDATE_SETTINGS } from 'gql/profile/mutations';
import { useAuthDispatchContext, useAuthStateContext } from 'providers/Auth';

import { Container } from './styled';
import AuthenticationModal from '../Modals/AuthenticationModal';
import { showErrorMessage } from 'utils/showErrorMessage';
import { instance } from 'utils/api';

const { Text } = Typography;

const Auth2FA: FC = () => {
  const { t } = useTranslation();
  const { toggleModal } = useUIDispatchContext();
  const { refetchUserData } = useAuthDispatchContext();
  const { user } = useAuthStateContext();

  const [updateSettings] = useMutation(UPDATE_SETTINGS, {
    onCompleted() {
      refetchUserData();
    },
    onError: err => showErrorMessage(err)
  });

  const [active, setActive] = useState(user?.settings?.auth2fa || false);

  const onToggleSwitch = useCallback(
    async (val: boolean) => {
      if (val) {
        const image = await instance.post('auth/qr');

        toggleModal('authentication', true, {
          qr: image?.data?.data?.qr,
          secretCode: image?.data?.data?.secretKey
        });
      } else {
        updateSettings({
          variables: {
            input: {
              settings: {
                ...(parseJson(user?.settings) || {}),
                [SettingsKeys.auth2fa]: false
              }
            }
          }
        });
      }

      setActive(val);
    },
    [toggleModal, updateSettings, user?.settings]
  );

  return (
    <Container>
      <Space>
        <Switch checked={active} onChange={onToggleSwitch} />
        <Text>{t('profile.2fa.title')}</Text>
      </Space>
      <AuthenticationModal onCancel={() => setActive(false)} />
    </Container>
  );
};

export default Auth2FA;
